import { Collection, Image, Span } from "@tblabs/truffle";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { GalleryItem } from "./GalleryItem";
import { EntryEdit } from "./EntryEdit";


export class GalleryItemEditor extends EntryEdit<GalleryItem>
{
    constructor(image: GalleryItem, images: Collection<GalleryItem>)
    {
        super(image, images);
    
        this.Append(
            new Table([], [
                ["Url", new Span(image.OriginalUrl)],
                ["Podgląd", new Image(image.MiniUrl)],
            ])
            .WidthPercent(100)
        );
    }
}
